import React, { Dispatch } from "react";

import { IgButton } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import {
  CreateOrModifySubscriptionReducerType,
  CreateSubscriptionReducerAction,
} from "../subscriptionReducer";

interface NewPhaseProps {
  payload: CreateOrModifySubscriptionReducerType;
  dispatchPayload: Dispatch<CreateSubscriptionReducerAction>;
}
export const NewPhase = ({ payload, dispatchPayload }: NewPhaseProps) => {
  const onClick = () => {
    dispatchPayload({ type: "addPhase" });
  };

  return (
    <Grid item>
      <IgButton
        variant={"outlined"}
        onClick={onClick}
        disabled={payload.status === "canceled"}
      >
        Add Phase
      </IgButton>
    </Grid>
  );
};
